export class Panel {
    constructor(
        private panelId: string,
        private step: number,
        private title: string,
        public selectedValue: string,
        public isActive: boolean,
        public isCompleted: boolean
    ) {}

    get PanelId(): string {
        return this.panelId;
    }
    get Step(): number {
        return this.step;
    }
    get Title(): string {
        return this.title;
    }
}
